export const removeScroll = ((active: boolean, state: any) => {
  if (active) {
    (state && state?.lenis) && state?.lenis?.stop();
    document.documentElement.classList.add("no-scroll");
  } else {
    (state && state?.lenis) && state?.lenis?.start();
    document.documentElement.classList.remove("no-scroll");
  }
})